angular.module('bmsApp.marketing').controller('CampaignOverviewCtrl', [
	'$scope',
	'$rootScope',
	'$timeout',
	'$log',
	'CampaignSvc',
	'ngTableParams',
	'$state',
	'$window',
	'InitiativeSvc',
	'InstanceSvc',
	'DashboardApiSvc',
	function ($scope, $rootScope, $timeout, $log, CampaignSvc, ngTableParams, $state, $window, InitiativeSvc, InstanceSvc, DashboardApiSvc) {


		$scope.loading = true;
		$scope.view = {
			allRevenue: false,
		};
		$scope.campaign = {};
		$scope.chartOptions = {
			animate: {
				duration: 1000,
				enabled: true
			},
			barColor: '#13CE66',
			trackColor: '#FF4949',
			size: 150,
			scaleColor: '#C2C4C4',
			lineWidth: 8,
			lineCap: 'circle'
		};

		$scope.newRevenueSwitch = function() {
			angular.extend($scope.campaign, {
				revenue_spend_ratio: $scope.view.allRevenue ? $scope.campaign.all_revenue_spend_ratio : $scope.campaign.new_revenue_spend_ratio,
			});
		};

		$scope.addInitiative = () => {
			$state.go('main.marketing.campaignIndex.campaignOverview.initiativeCreate', {campaignId: $scope.campaign.id});
		};

		CampaignSvc.read($state.params.campaignId)
			.then(function (response) {
				$scope.campaign = response.data.campaign;

				let params = {
					filter: {
						from: $scope.campaign.start_date,
						to: $scope.campaign.end_date,
						franchise: {
							id: InstanceSvc.instance.getFranchiseId(),
						},
						campaign:{
							id: $state.params.campaignId,
						},
						view: 'local',
						api_key: InstanceSvc.instance.getFranchiseApiKey(),
					},
				};

				DashboardApiSvc.initiativeMetrics(params).then((response) => {
					$scope.initiativeMetrics = response.data.bms_initiative_collection;
					calculateTotals();
					$scope.loading = false;
				});
			});

		function calculateTotals() {
			let enquiryCount = 0;
			let quotesCount = 0;
			let totalJobsCount = 0;
			let totalFirstJobCount = 0;
			let totalAvgJobValue = 0;
			let totalFirstJobAvgValue = 0;
			let totalJobsValue = 0;
			let totalFirstJobsValue = 0;
			let totalCost = 0;
			let totalRoi = 0;
			let totalFirstJobRoi = 0;
			angular.forEach($scope.initiativeMetrics, (initiative) => {
				enquiryCount += initiative.enquiry_count;
				quotesCount += initiative.total_quote_count;
				totalJobsCount += initiative.converted_quote_count;
				totalFirstJobCount += initiative.first_job_count;
				totalAvgJobValue += initiative.job_avg_value;
				totalFirstJobAvgValue += initiative.avg_first_job_value;
				totalJobsValue += initiative.job_total_value;
				totalFirstJobsValue += initiative.first_job_value;
				totalCost += initiative.cost;
				totalRoi += initiative.total_job_roi;
				totalFirstJobRoi += initiative.first_job_roi;
			});

			$timeout(() => {
				angular.extend($scope.campaign, {
					enquiry_count: enquiryCount,
					total_quote_count: quotesCount,
					converted_quote_count: totalJobsCount,
					first_job_count: totalFirstJobCount,
					job_avg_value: totalAvgJobValue,
					avg_first_job_value: totalFirstJobAvgValue,
					job_total_value: totalJobsValue,
					first_job_value: totalFirstJobsValue,
					cost: totalCost,
					total_job_roi: totalJobsValue - totalCost,
					first_job_roi: totalFirstJobsValue - totalCost,
					new_revenue_spend_ratio: parseInt((totalFirstJobsValue / totalCost * 100).toFixed(0)),
					all_revenue_spend_ratio: parseInt((totalJobsValue / totalCost * 100).toFixed(0)),
				});

				let ratio = $scope.view.allRevenue ? $scope.campaign.all_revenue_spend_ratio | 0 : $scope.campaign.new_revenue_spend_ratio | 0;
				console.log('ratio', ratio);
				angular.extend($scope.campaign, {
					revenue_spend_ratio: ratio,
				});
			});


		}

		$scope.rowClicked = function(initiative) {
			$state.go('main.marketing.campaignIndex.campaignOverview.initiativeUpdate', {initiativeId: initiative.id});
		};

		$scope.deleteInitiative = function(initiative){
			InitiativeSvc.delete(initiative, initiative.id).then(function(response){
				index = $scope.campaign.initiatives.indexOf(initiative);
				$scope.campaign.initiatives.splice(index, 1);
			});
		};

	}]);


